import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 26 27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M.866 26.067h11.76m-6.72-5.6h11.76m.84-5.6v-7.84m0 0V.867s-2.59.84-4.34.84-4.34-.84-4.34-.84v6.16s2.59.84 4.34.84 4.34-.84 4.34-.84m-5.88 7.84h11.76"
    }, null, -1)
  ]))]))
}
export default { render: render }